import { render, staticRenderFns } from "./ProductDetailLeaflet.vue?vue&type=template&id=0f3f8dd2"
import script from "./ProductDetailLeaflet.vue?vue&type=script&lang=js"
export * from "./ProductDetailLeaflet.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailLeaflet.vue?vue&type=style&index=0&id=0f3f8dd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports